(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-cl001-cro"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const panel = document.querySelector(".ss-cl001-size");
    const root = panel && panel.closest(".m-main-product");
    if (!panel || !root || root.dataset.cl001CroReady === "true") return;
    root.dataset.cl001CroReady = "true";
    root.classList.add("ss-cl001-page");

    const cartText = panel.dataset.cartText;
    const selectedText = panel.dataset.selectedText;
    const selectedOutput = panel.querySelector(".ss-cl001-size__selected");
    const sizeError = panel.querySelector(".ss-cl001-size__error");
    const getPicker = () => root.querySelector('variant-picker [data-option-name*="size" i]');
    let sizeChosenByCustomer = new URLSearchParams(window.location.search).has("variant");
    const buttons = Array.from(
      document.querySelectorAll(
        '.m-main-product .m-product-form--main button[name="add"], .m-sticky-addtocart button[name="add"]'
      )
    );

    const setText = (button, text) => {
      const label = button.querySelector(".m-add-to-cart--text");
      if (label && label.textContent !== text) label.textContent = text;
    };

    const selected = () => {
      if (!sizeChosenByCustomer) return "";
      const picker = getPicker();
      if (!picker) return "";
      const radio = picker.querySelector('input[type="radio"]:checked:not(:disabled)');
      if (radio && radio.getAttribute("aria-disabled") !== "true") return radio.value;
      const select = picker.querySelector("select");
      const option = select && select.selectedOptions ? select.selectedOptions[0] : null;
      return option && option.value && !option.disabled ? option.value : "";
    };

    const setGuidedState = (button) => {
      if (button.hasAttribute("disabled")) button.removeAttribute("disabled");
      if (button.getAttribute("aria-disabled") !== "true") {
        button.setAttribute("aria-disabled", "true");
      }
      button.classList.remove("disabled", "ss-cl001-cro-ready");
      button.classList.add("ss-cl001-cro-disabled");
      setText(button, cartText);
    };

    const setReadyState = (button) => {
      button.removeAttribute("disabled");
      button.removeAttribute("aria-disabled");
      button.classList.remove("disabled", "ss-cl001-cro-disabled");
      button.classList.add("ss-cl001-cro-ready");
      setText(button, cartText);
    };

    const updateSelectedSize = (value) => {
      if (!selectedOutput) return;
      selectedOutput.hidden = !value;
      selectedOutput.textContent = value ? `${selectedText} ${value} ✓` : "";
    };

    const clearSizeError = () => {
      if (sizeError) sizeError.hidden = true;
      panel.classList.remove("ss-cl001-size--attention");
    };

    const syncButtonState = () => {
      const value = selected();
      updateSelectedSize(value);
      if (value) clearSizeError();
      buttons.forEach(value ? setReadyState : setGuidedState);
    };

    const showSizeError = () => {
      if (sizeError) sizeError.hidden = false;
      panel.classList.add("ss-cl001-size--attention");
      const picker = getPicker();
      const target =
        (picker && picker.closest(".m-product-option")) ||
        picker ||
        panel;
      target.scrollIntoView({ behavior: "smooth", block: "center" });
      window.setTimeout(() => {
        const control = getPicker()?.querySelector(
          'input[type="radio"]:not(:disabled), select:not(:disabled)'
        );
        control?.focus({ preventScroll: true });
      }, 450);
    };

    const blockMissingSize = (event) => {
      if (selected()) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      syncButtonState();
      showSizeError();
    };

    buttons.forEach((button) => {
      button.addEventListener("click", blockMissingSize, true);
      const form = button.closest("form");
      form?.addEventListener("submit", blockMissingSize, true);
    });

    let settleTimers = [];
    const settleButtonState = () => {
      settleTimers.forEach((timer) => window.clearTimeout(timer));
      syncButtonState();
      settleTimers = [40, 160, 500].map((delay) =>
        window.setTimeout(syncButtonState, delay)
      );
    };

    root.addEventListener(
      "change",
      (event) => {
        if (!event.target.closest('variant-picker [data-option-name*="size" i]')) return;
        sizeChosenByCustomer = true;
        settleButtonState();
      },
      true
    );

    root.addEventListener(
      "click",
      (event) => {
        if (!event.target.closest('variant-picker [data-option-name*="size" i]')) return;
        window.requestAnimationFrame(settleButtonState);
      },
      true
    );

    syncButtonState();

    const hideEmptyReviews = () => {
      document.querySelectorAll(
        '.jdgm-prev-badge[data-number-of-reviews="0"],.jdgm-widget[data-number-of-reviews="0"],[data-reviews-count="0"]'
      ).forEach((reviewElement) => {
        const block = reviewElement.closest(".main-product__block");
        const target = block || reviewElement;
        if (!target.hidden) target.hidden = true;
      });
    };

    hideEmptyReviews();
    window.setTimeout(hideEmptyReviews, 1500);
    window.setTimeout(hideEmptyReviews, 4000);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
